import { type MutableRefObject } from 'react';

import type { OutcomeFollowUpAction } from '@modules/_shared/components/feed/activityOutcomeShared';

export const createNextStepsCloseHandler = <
  Action extends OutcomeFollowUpAction,
>(
  selectedActionRef: MutableRefObject<Action | null>,
  handleCloseNextSteps: () => void,
): (() => void) => {
  return () => {
    if (
      selectedActionRef.current === 'lead_lost' ||
      selectedActionRef.current === 'lead_won'
    ) {
      selectedActionRef.current = null;
      return;
    }

    handleCloseNextSteps();
    selectedActionRef.current = null;
  };
};
